// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"97":"5f7a37ce","160":"c7def10d","425":"a70f6075"}[chunkId] + ".css";
};